module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03-en.bf24be34ea6e5fcbc9b772be75c6c3c5.png";